import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  CheckCircleOutline as CheckIcon,
  BalanceOutlined as BalanceIcon,
  UpdateOutlined as UpdateIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

/**
 * Trust Hero Bar - renders 3 trust signals below the page H1.
 * Subtle background, outline icons, one-line layout.
 */
const TrustHeroBar = ({ freshnessLabel }) => {
  const { t } = useTranslation();
  const signals = [
    { Icon: CheckIcon, text: t('trustHeroBar.verifiedData') },
    { Icon: BalanceIcon, text: t('trustHeroBar.noBias') },
    { Icon: UpdateIcon, text: `${t('trustHeroBar.updated')} ${freshnessLabel || t('trustHeroBar.recently')}` },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1.5, md: 4 },
        flexWrap: 'wrap',
        py: 1.5,
        px: 2,
        mb: 2.5,
        bgcolor: 'neutral.25',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      {signals.map((s, i) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <s.Icon sx={{ fontSize: '1rem', color: 'success.main' }} />
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            {s.text}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default TrustHeroBar;
